import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function isDateInRange(beforeOrAfter: number, referenceDateControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (referenceDateControl === null || !!referenceDateControl?.value === false || !!control?.value === false) {
      return null;
    }
    const [THIS_YEAR, THIS_MONTH, THIS_DATE] = control.value.split('-');
    const THE_DATE = new Date(`${THIS_MONTH}/${THIS_DATE}/${THIS_YEAR}`);
    const [REF_YEAR, REF_MONTH, REF_DATE] = referenceDateControl.value.split('-');
    const REFERENCE_DATE = new Date(`${REF_MONTH}/${REF_DATE}/${REF_YEAR}`);
    if (
      (beforeOrAfter < 0 && THE_DATE.getTime() >= REFERENCE_DATE.getTime()) ||
      (beforeOrAfter > 0 && THE_DATE.getTime() <= REFERENCE_DATE.getTime())
    ) {
      return {
        dateInRange: {
          valid: false
        }
      };
    }
    return null;
  };
}
